import React, { useEffect } from "react";
import useLayoutStore from "stores/layoutStore";
import useAuthStore from "stores/authStore";
import useMenuStore from "stores/menuStore";
import useSettingsStore from "stores/settingsStore";
import classNames from "classnames";
import { Col, Dropdown, Row } from "react-bootstrap";
import { useNavigate } from "@tanstack/react-router";
import { MENU_PLACEMENT } from "../../utils/constant";

const NavUserMenuContent = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Row className="mb-3 ms-0 me-0">
        <Col xs="12" className="ps-1 mb-2">
          <div className="text-extra-small text-primary">ACCOUNT</div>
        </Col>
        <Col xs="6" className="ps-1 pe-1">
          <ul className="list-unstyled">
            <li>
              <a
                href="#/!"
                onClick={(e) => {
                  e.preventDefault();
                  navigate({ to: "/account/settings" });
                }}
              >
                User Info
              </a>
            </li>

            <li>
              <a
                href="#/!"
                onClick={() => {
                  useAuthStore.getState().logout();
                  navigate({ to: "/login" });
                }}
              >
                Logout
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
};

const NavUserMenuDropdownToggle = React.memo(
  React.forwardRef(({ onClick, expanded = false, user = {} }, ref) => (
    <a
      href="#/!"
      ref={ref}
      className="d-flex user position-relative"
      data-toggle="dropdown"
      aria-expanded={expanded}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
    >
      <img
        className="profile"
        alt={user.name}
        src={user.thumb ? user.thumb : "/img/user.webp"}
      />
      <div className="name">
        <h4>{user.name}</h4>
        <p>{user.email}</p>
      </div>
    </a>
  ))
);

const NavUserMenuDropdownMenu = React.memo(
  React.forwardRef(({ style, className }, ref) => {
    return (
      <div
        ref={ref}
        style={style}
        className={classNames(
          "dropdown-menu dropdown-menu-end user-menu wide",
          className
        )}
      >
        <NavUserMenuContent />
      </div>
    );
  })
);

NavUserMenuDropdownMenu.displayName = "NavUserMenuDropdownMenu";

const MENU_NAME = "NavUserMenu";

const NavUserMenu = () => {
  const {
    placementStatus: { view: placement },
    behaviourStatus: { behaviourHtmlData },
    attrMobile,
    attrMenuAnimate,
  } = useMenuStore();

  const { isLogin, currentUser } = useAuthStore();
  const { color } = useSettingsStore();
  const { showingNavMenu, layoutShowingNavMenu } = useLayoutStore();

  const onToggle = (status, event) => {
    if (event && event.stopPropagation) event.stopPropagation();
    else if (
      event &&
      event.originalEvent &&
      event.originalEvent.stopPropagation
    )
      event.originalEvent.stopPropagation();
    layoutShowingNavMenu(status ? MENU_NAME : "");
  };

  useEffect(() => {
    layoutShowingNavMenu("");
    // eslint-disable-next-line
  }, [attrMenuAnimate, behaviourHtmlData, attrMobile, color]);

  if (!isLogin) {
    return <></>;
  }
  return (
    <Dropdown
      as="div"
      bsPrefix="user-container d-flex"
      onToggle={onToggle}
      show={showingNavMenu === MENU_NAME}
      drop="down"
    >
      <Dropdown.Toggle as={NavUserMenuDropdownToggle} user={currentUser} />
      <Dropdown.Menu
        as={NavUserMenuDropdownMenu}
        className="dropdown-menu dropdown-menu-end user-menu wide"
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: () => {
                  if (placement === MENU_PLACEMENT.Horizontal) {
                    return [0, 7];
                  }
                  if (window.innerWidth < 768) {
                    return [-84, 7];
                  }

                  return [-78, 7];
                },
              },
            },
          ],
        }}
      />
    </Dropdown>
  );
};
export default React.memo(NavUserMenu);
